import React from 'react';
import { DeleteOutlineTwoToneIcon } from 'tuui';
import { useDeleteConversionEvent } from '../../hooks/useDeleteConversionEvent';
import { ConversionTypeHeader } from '../ConversionTypeHeader/ConversionTypeHeader';
import styles from './reviewEventCard.module.scss';

export const ReviewEventCard = ({ event, setFocusedConversionId }) => {
    const handleDeleteConversion = useDeleteConversionEvent(event.id);
    const handleMouseEnter = () => setFocusedConversionId(event.id);
    const handleMouseLeave = () => setFocusedConversionId(undefined);

    return (
        <div className={styles['inner']} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <div className={styles['header']}>
                <ConversionTypeHeader event={event} />
                <div className={styles['delete-button']}>
                    <DeleteOutlineTwoToneIcon color="error" onClick={handleDeleteConversion} />
                </div>
            </div>
        </div>
    );
};
